!function() {
  "use strict";
  window.Geo = new class {
    cookie=!1;
    cookieSelector="lechameau_geolocation";
    constructor() {
      window.Geo = this;
    }
    async init(e = !1) {
      fetch(Shopify.routes.root + "browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true").then((e => e.json())).then((t => {
        this.cookie = t, this.setGeolocationCookie(t), e && e(t);
      })).catch((e => {
        console.warn(e);
      }));
    }
    setGeolocationCookie(e) {
      sessionStorage.setItem(this.cookieSelector, JSON.stringify(e));
    }
    getLocation(e = !1) {
      this.cookie = this.getGeolocationCookie(), this.init(e);
    }
    getGeolocationCookie() {
      const e = sessionStorage.getItem(this.cookieSelector);
      return !(!e || !JSON.parse(e).detected_values?.country_name) && JSON.parse(e);
    }
  }, new class {
    loading=[];
    header=document.querySelector("header");
    async importScript(e) {
      const t = e.tagName.toLowerCase(), o = "127.0.0.1" === location.hostname || Shopify && Shopify.theme && -1 !== Shopify.theme.name.indexOf("Development") || Shopify.designMode;
      if (-1 === this.loading.indexOf(t) && (this.loading.push(t), !customElements.get(t))) {
        var i = document.createElement("script");
        i.src = `${window.settings.asset_url || "/assets/"}${t}.js?v=${o ? Date.now() : window.settings.asset_revision || Date.now()}`, 
        i.async = !0, o && (i.onload = () => console.info(`Loaded: ${t}`)), i.onerror = () => console.warn(`Failed to load ${t}.`) && this.loading.splice(this.loading.indexOf(t)), 
        document.body.appendChild(i);
      }
    }
    loadScript(e) {
      e.hasAttribute("data-autoload") ? this.importScript(e) : new IntersectionObserver((async (t, o) => {
        t.forEach((async t => {
          t.isIntersecting && (this.importScript(e), o.disconnect());
        }));
      }), {
        rootMargin: "0px 0px 200% 0px"
      }).observe(e);
    }
    initJavascript() {
      document.querySelectorAll("[data-async]").forEach((e => this.loadScript(e))), new MutationObserver(((e, t) => {
        e.forEach((e => {
          e.target.querySelectorAll("[data-async]").forEach((e => this.loadScript(e)));
        }));
      })).observe(document.querySelector("body"), {
        childList: !0,
        subtree: !0,
        characterData: !1,
        attributes: !1
      });
    }
    initCloser() {
      window.addEventListener("keydown", (e => {
        "Escape" === e.key && (document.querySelectorAll("[data-locker]").forEach((e => e.checked = !1)), 
        document.body.classList.remove("overflow-hidden"));
      }));
    }
    scrollLock() {
      setTimeout((() => document.querySelectorAll("[data-locker]:checked").length ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden")), 100);
    }
    initScrollLock() {
      window.addEventListener("click", (e => {
        e.target.closest("teleport-details") || Shopify.debounce(this.scrollLock());
      }));
    }
    initClicks() {
      window.addEventListener("click", (e => {
        switch (e.target.tagName?.toUpperCase()) {
         case "LABEL":
          (t = e.target.querySelector("input") || document.getElementById(e.target.getAttribute("for"))) && -1 === t.name.toLowerCase().indexOf("filter") && t.classList.contains("hidden") && (e.preventDefault(), 
          e.stopPropagation(), t.checked = !t.checked, e.target.dispatchEvent(new Event("input", {
            bubbles: !0
          })), Shopify.debounce(this.scrollLock()));
          break;

         case "INPUT":
          "Search" == e.target.id && e.target.checked && (e.target.checked = !1);
          break;

         case "BUTTON":
         case "A":
          if (e.target.getAttribute("href")?.match(/\/cart$/) && !e.target.closest("shopping-cart")) e.preventDefault(), 
          document.querySelector("#Cart").checked = !document.querySelector("#Cart").checked; else {
            if (e.target.getAttribute("href")?.toLowerCase().includes("#accessibility") || e.target.getAttribute("href")?.toLowerCase().includes("#a11y")) return e.preventDefault(), 
            window.interdeal.a11y.openMenu(), !1;
            var t;
            e.target.getAttribute("href")?.match(/^#/) && "#" !== e.target.getAttribute("href") && (t = document.querySelector(e.target.getAttribute("href"))) && (e.preventDefault(), 
            window.scrollTo({
              top: t.offsetTop - this.header?.clientHeight,
              left: 0,
              behavior: "smooth"
            }));
          }
        }
      }));
    }
    labelAccessibility() {
      document.querySelectorAll("label").forEach((e => {
        if (e.hasAttribute("for")) {
          const t = document.getElementById(e.getAttribute("for"));
          t && (e.setAttribute("aria-labelledby", t.id), e.setAttribute("role", "button"), 
          e.setAttribute("tabindex", "0"), e.addEventListener("keydown", (e => {
            if (("Enter" === e.key || " " === e.key) && (e.preventDefault(), t.click(), "mobile-menu" == t.name)) {
              const e = document.getElementById(t.id.replace("-toggle", "-content"));
              e && e.querySelector("[tabindex]")?.focus();
            }
          })));
        }
      }));
    }
    trackRecentlyViewed() {
      Shopify = Shopify || {}, Shopify.recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
      const e = location.href.match("/products/([^?#]+)");
      if (e) {
        const t = Shopify.recentlyViewed.indexOf(e[1]);
        t > -1 && Shopify.recentlyViewed.splice(t, 1), Shopify.recentlyViewed.unshift(e[1]), 
        Shopify.recentlyViewed = Shopify.recentlyViewed.slice(0, 8), localStorage.setItem("recentlyViewed", JSON.stringify(Shopify.recentlyViewed));
      }
    }
    visualViewport() {
      document.documentElement.style.setProperty("--header-height", document.querySelector("header")?.clientHeight - 1 + "px"), 
      document.documentElement.style.setProperty("--header-height-full", `${Array.from(document.querySelectorAll(".shopify-section-group-header-group")).reduce(((e, t) => e + t.clientHeight), 0)}px`), 
      document.documentElement.style.setProperty("--announcement-height", `${document.querySelector("[data-announcement]")?.clientHeight}px`);
    }
    scrollTrigger() {
      const e = document.querySelector("[data-announcement");
      e && new IntersectionObserver((e => {
        e[0].isIntersecting ? document.body.classList.remove("is-scrolled") : document.body.classList.add("is-scrolled");
      })).observe(e);
    }
    constructor() {
      this.initJavascript(), this.initCloser(), this.initScrollLock(), this.initClicks(), 
      this.labelAccessibility(), this.scrollTrigger(), this.trackRecentlyViewed(), this.visualViewport(), 
      document.addEventListener("DOMContentLoaded", (() => {
        this.visualViewport(), (window.visualViewport || window).addEventListener("resize", Shopify.debounce(this.visualViewport), {
          passive: !0
        });
      })), window.addEventListener("load", (() => {
        const e = window.location.href;
        if (e.includes("form_type=customer")) {
          var t = (t = e.split("#")).length > 1 ? t[t.length - 1] : "footer", o = document.querySelector(`#${t}`) || document.querySelector('footer[action^="/contact"]');
          if (o) {
            const e = o.querySelector('[type="email"]');
            if (e && e.value.length > 0) {
              const e = document.createElement("p");
              e.classList.add("mt-sm"), e.innerText = window.strings.existing, o.appendChild(e), 
              window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                event: "newsletter_signup",
                form_action: "submit-failure",
                error_id: window.strings.existing
              });
            }
          }
        }
      }));
    }
  };
}();